import type { ISVG } from './index';

/** Inbox + down-arrow — "extract iRev results into the store". Sidebar nav icon. */
export const IRevExtractionSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '20'}
		height={height || '20'}
		viewBox='0 0 24 24'
		fill='none'
	>
		{/* Extraction arrow (pulled down from the external iRev source) */}
		<path
			d='M12 3v8.5'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M8.5 8 12 11.5 15.5 8'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
			fill='none'
		/>
		{/* Result store / inbox tray */}
		<path
			d='M4 13.5h3.5l1.1 2.2h6.8l1.1-2.2H20'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
			fill='none'
		/>
		<path
			d='M4 13.5v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
			fill='none'
		/>
	</svg>
);
